import { render, staticRenderFns } from "./dataone.vue?vue&type=template&id=3e1f12ab&scoped=true&"
import script from "./dataone.vue?vue&type=script&lang=js&"
export * from "./dataone.vue?vue&type=script&lang=js&"
import style0 from "./dataone.vue?vue&type=style&index=0&id=3e1f12ab&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1f12ab",
  null
  
)

export default component.exports